import { createTheme } from "@mui/material";

export const theme = createTheme({
  breakpoints: {
    values: {
      mobile: 0,
      tablet: 769,
      laptop: 1025,
      desktop: 1201,
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: "#000000",
    },
    background: {
      default: "#eeeeee",
      paper: "#ffffff",
      inverted: "#000000",
    },
    text: {
      primary: "#000000",
      secondary: "#585858",
      tertiary: "#a1a1a1",
      inverted: "#ffffff",
    },
    link: {
      primary: "#000000",
      secondary: "#a1a1a1",
    },
  },
  typography: {
    fontFamily: ["TTCommons"].join(","),
    h1: {
      fontFamily: "kansasnew",
      fontSize: 18,
      fontWeight: 700,
      lineHeight: 1.5,
    },
    h2: {
      fontFamily: "kansasnew",
      fontSize: 28,
      fontWeight: 700,
      lineHeight: 1.5,
      marginBottom: "0.5rem",
    },
    h3: {
      fontFamily: "kansasnew",
      fontSize: 16,
      fontWeight: 700,
      lineHeight: 1.5,
      marginBottom: "0.5rem",
    },
    h4: {
      fontFamily: "kansasnew",
      fontSize: 14,
      fontWeight: 700,
      lineHeight: 1.5,
      marginBottom: "0.5rem",
    },
    button: {
      fontSize: 14,
      fontWeight: 700,
      textTransform: false,
      lineHeight: 2,
      letterspacing: "-2.2%",
    },
    body2: {
      fontSize: 16,
      fontWeight: 700,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "kansasnew",
          whiteSpace: "nowrap",
          borderRadius: 20,
          paddingLeft: 48,
          paddingRight: 48,
        },
      },
      variants: [
        {
          props: { variant: "inverted" },
          style: {
            backgroundColor: "transparent",
            color: "#ffffff",
            border: "1px solid #ffffff",
          },
        },
      ],
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none",
          fontWeight: 700,
        },
      },
    },
  },
});
